/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-23T16:11:31.639
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveChanneltag,
	getChanneltagCreateInit,
	getChanneltagEditInit,
	getChanneltagView,
	deleteChanneltag
} from '@api/rentmanage/Channeltag';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getChanneltagCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getChanneltagCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getChanneltagEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getChanneltagEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveChanneltag({}, Channeltag) {
			return new Promise((resolve, reject) => {
				saveChanneltag(Channeltag)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getChanneltagView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getChanneltagView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteChanneltag({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteChanneltag({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
